import { useState, useEffect } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from './assets/images.jpg';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navButtonClass = "bg-[#052e5a] hover:bg-[#041d3a] text-white font-medium rounded px-4 py-2 cursor-pointer";
  const navLinkClass = "text-gray-700 hover:text-[#052e5a] transition font-light tracking-wide text-sm uppercase cursor-pointer relative";
  const activeNavLinkClass = "text-[#052e5a] font-normal relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-full after:h-0.5 after:bg-[#052e5a]";

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm py-2' : 'bg-white/90 backdrop-blur-sm py-4'}`}>
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div
            onClick={() => handleNavigation('/')}
            className="flex items-center cursor-pointer"
          >
            <img src={logo} alt="Donzi Art Academy" className="h-20 w-auto" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <div
              onClick={() => handleNavigation('/')}
              className={`${navLinkClass} ${isActive('/') ? activeNavLinkClass : ''}`}
            >
              Home
            </div>
            <div
              onClick={() => handleNavigation('/about')}
              className={`${navLinkClass} ${isActive('/about') ? activeNavLinkClass : ''}`}
            >
              About Us
            </div>
            <div
              onClick={() => handleNavigation('/donzi')}
              className={`${navLinkClass} ${isActive('/donzi') ? activeNavLinkClass : ''}`}
            >
              Donzi El Husseiny
            </div>
            <div
              onClick={() => handleNavigation('/exhibitions')}
              className={`${navLinkClass} ${isActive('/exhibitions') ? activeNavLinkClass : ''}`}
            >
              Exhibitions
            </div>
            <div
              onClick={() => handleNavigation('/global-egyptian-youth')}
              className={`${navLinkClass} ${isActive('/global-egyptian-youth') ? activeNavLinkClass : ''}`}
            >
              Global Egyptian Youth
            </div>
            <div
              onClick={() => handleNavigation('/register')}
              className={`${navButtonClass} text-sm uppercase tracking-wide flex items-center gap-1`}
            >
              Register <FaArrowRight className="text-xs" />
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <div
            className="lg:hidden text-gray-700 focus:outline-none cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-white py-4 px-4 space-y-3 shadow-lg mt-2">
            <div
              onClick={() => handleNavigation('/')}
              className={`${navLinkClass} ${isActive('/') ? activeNavLinkClass : ''}`}
            >
              Home
            </div>
            <div
              onClick={() => handleNavigation('/about')}
              className={`${navLinkClass} ${isActive('/about') ? activeNavLinkClass : ''}`}
            >
              About Us
            </div>
            <div
              onClick={() => handleNavigation('/donzi')}
              className={`${navLinkClass} ${isActive('/donzi') ? activeNavLinkClass : ''}`}
            >
              Donzi
            </div>
            <div
              onClick={() => handleNavigation('/exhibitions')}
              className={`${navLinkClass} ${isActive('/exhibitions') ? activeNavLinkClass : ''}`}
            >
              Exhibitions
            </div>
            <div
              onClick={() => handleNavigation('/global-egyptian-youth')}
              className={`${navLinkClass} ${isActive('/global-egyptian-youth') ? activeNavLinkClass : ''}`}
            >
              Global Egyptian Youth
            </div>
            <div
              onClick={() => handleNavigation('/register')}
              className={`${navButtonClass} block text-center mt-2 text-sm uppercase tracking-wide flex items-center justify-center gap-1`}
            >
              Register <FaArrowRight className="text-xs" />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;